import { render, staticRenderFns } from "./ClinicianAlertTable.vue?vue&type=template&id=0bc121c3"
import script from "./ClinicianAlertTable.vue?vue&type=script&lang=js"
export * from "./ClinicianAlertTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports